export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "什么是韩国妖精漫画？",
    a: "韩国妖精漫画泛指以妖精、妖怪、灵兽等奇幻角色为核心的韩国漫画（manhwa）。这类作品通常以『女主颜值与人设』『萌娘属性』『CP组合』为看点，讲述人与妖、妖与妖之间充满奇幻色彩与浪漫张力的故事。本图鉴站就是围绕这类作品的女主角色进行系统盘点与整理。",
  },
  {
    q: "角色图鉴里的『萌娘属性』是什么？",
    a: "萌娘属性是粉丝圈对角色性格特征的概括性标签，比如傲娇、软萌、腹黑、御姐、天然呆、元气、清冷等。本站在每个角色页都标注了多重属性标签，方便你快速判断这位女主是不是你的『天菜』。",
  },
  {
    q: "『CP组合』是怎么排的？",
    a: "CP（Coupling）指作品中成对的角色关系，通常以官配、热门或同人向组合划分。本站收录每位女主的主要CP与人物关系线，标注其性格张力与看点，方便你判断是否合口味。热度仅供参考，不代表官方立场。",
  },
  {
    q: "为什么有些作品显示『连载中』有些是『已完结』？",
    a: "这是根据作品的连载状态整理的信息。连载中的作品我们会随更新持续补充角色资料与人物关系；已完结的作品则提供完整的角色图鉴。如果某部作品状态有变动，我们会及时更新。",
  },
  {
    q: "如何快速找到想看的妖精漫画女主？",
    a: "你可以通过顶部的『角色图鉴』按身份（妖灵、神族、人类等）或萌娘属性（傲娇、软萌等）筛选，也可以直接点进『作品大全』，从作品页进入其女主角色详情。每个角色都配有清晰的人设介绍与CP关系。",
  },
  {
    q: "图鉴里的角色信息和评分准确吗？",
    a: "本站的角色介绍、萌娘属性与CP关系均根据作品公开剧情与读者讨论整理，尽力做到客观准确。人气分与CP热度为站内读者投票与讨论量的综合参考，欢迎在评论区交流补充你的看法。",
  },
  {
    q: "可以投稿自己整理的妖精漫画角色资料吗？",
    a: "当然可以。如果你有想补充的韩国妖精漫画角色资料、冷门萌娘人设或独家CP整理，欢迎通过页面底部的联系方式或『关于我们』页面的投稿表单告诉我们。经审核后，我们会将优秀内容收录进图鉴并标注来源。",
  },
];